"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("../../components/utils/helpers");
var _colors = require("../colors.config");
var _default = function _default(isFontBigger, isHighContrast) {
  return {
    avatar: {
      backgroundColor: 'white',
      height: '58px',
      marginLeft: 0,
      marginRight: 0,
      position: 'static',
      width: '58px'
    },
    clickable: {
      '&:active, &:focus, &:hover': {
        '& .MuiChip-label': {
          color: isHighContrast ? _helpers.agentDeveloperUtils.getPrimaryColor(300) : _helpers.agentDeveloperUtils.getPrimaryColor(450)
        },
        backgroundColor: isHighContrast ? _helpers.agentDeveloperUtils.getPrimaryColor(300) : _helpers.agentDeveloperUtils.getPrimaryColor(50),
        fontWeight: 'bold',
        letterSpacing: -0.2,
        opacity: '1'
      }
    },
    label: {
      color: isHighContrast ? _colors.Black[0] : _colors.Black[170],
      display: 'block',
      fontFamily: 'Open-sans-hebrew',
      fontSize: isFontBigger ? '17px' : '12px',
      lineHeight: '13px',
      paddingLeft: 0,
      paddingRight: 0,
      position: 'absolute',
      textAlign: 'center',
      top: '80px',
      whiteSpace: 'normal',
      width: 'inherit'
    },
    root: {
      '& .MuiAvatar-img': {
        height: '40px',
        objectFit: 'contain',
        padding: '4px',
        width: '52px'
      },
      '&> div.MuiChip-avatar': {
        marginLeft: 0,
        marginRight: 0
      },
      backgroundColor: isHighContrast ? 'black' : 'white',
      border: "1px solid ".concat(_colors.Black[100]),
      borderRadius: '50%',
      height: '72px',
      position: 'relative',
      width: '72px'
    }
  };
};
exports.default = _default;